import {
	getDoctorStatusText,
	getRhStatusText,
} from '../components/Status/formatter';

export const optionsMedicStatus = [
	{
		id: 'pendent',
		value: getDoctorStatusText('pendent'),
	},
	{
		id: 'appointmentRequested',
		value: getDoctorStatusText('appointmentRequested'),
	},
	{
		id: 'appointmentAccepted',
		value: getDoctorStatusText('appointmentAccepted'),
	},
	{
		id: 'compatible',
		value: getDoctorStatusText('compatible'),
	},
	{
		id: 'incompatible',
		value: getDoctorStatusText('incompatible'),
	},
	{
		id: 'incomplete',
		value: getDoctorStatusText('incomplete'),
	},
	{
		id: 'conditional',
		value: getDoctorStatusText('conditional'),
	},
];

export const optionsStatusRH = [
	{
		id: 'pendent',
		value: getRhStatusText('pendent'),
	},
	{
		id: 'approved',
		value: getRhStatusText('approved'),
	},
	{
		id: 'rejected',
		value: getRhStatusText('rejected'),
	},
];
